const API_BASE = process.env.REACT_APP_SCENARIO_OS_API || '';
const BASE = `${API_BASE}/scenario-os/metrics`;

function authHeaders(token) {
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}

export const metricsAPI = {
  getLearnerProgress: (token) =>
    fetch(`${BASE}/learner/progress`, { headers: authHeaders(token) }).then(r => r.json()),

  getLearnerActivity: (token, days = 30) =>
    fetch(`${BASE}/learner/activity?days=${days}`, { headers: authHeaders(token) }).then(r => r.json()),

  getLearnerSkills: (token) =>
    fetch(`${BASE}/learner/skills`, { headers: authHeaders(token) }).then(r => r.json()),

  getCoachDashboard: (token, domain) =>
    fetch(`${BASE}/coach/dashboard?domain=${domain || ''}`, { headers: authHeaders(token) }).then(r => r.json()),

  getCoachLearnerDetail: (token, learnerId, domain) =>
    fetch(`${BASE}/coach/learner/${learnerId}?domain=${domain || ''}`, { headers: authHeaders(token) }).then(r => r.json()),

  getContentEffectiveness: (token, domain) =>
    fetch(`${BASE}/coach/content-effectiveness?domain=${domain || ''}`, { headers: authHeaders(token) }).then(r => r.json()),
};
